import { db } from "../../config/firebaseInitial";
import firebase from "firebase/app";

export const SELECTED_NEEDS = "SELECTED_NEEDS";
export const setNeeds = needs => {
  return {
    type: SELECTED_NEEDS,
    value: needs
  };
};

export const SUBMIT_NEEDS_REQUEST = "SUBMIT_NEEDS_REQUEST";
export const SUBMIT_NEEDS_SUCCESS = "SUBMIT_NEEDS_SUCCESS";
export const SUBMIT_NEEDS_FAILURE = "SUBMIT_NEEDS_FAILURE";
const submitNeedsRequest = () => {
  return {
    type: SUBMIT_NEEDS_REQUEST
  };
};

const submitNeedsSuccess = () => {
  return {
    type: SUBMIT_NEEDS_SUCCESS
  };
};

const submitNeedsError = error => {
  return {
    type: SUBMIT_NEEDS_FAILURE,
    error
  };
};

export const addNeedsToFirestore = needsData => dispatch => {
  dispatch(submitNeedsRequest());
  let needsObj = {};
  needsData.needs.map(item =>
  (needsObj[item.id] = {
    needStatus: "pending",
    theNeed: item.value,
    uid: ""
  })
  );
  db.collection("cards")
    .add({
      name: needsData.fullName,
      phoneNumber: needsData.phoneNumber,
      prov: needsData.prov,
      location: needsData.location,
      cardStatus: "pending",
      workerCard: [],
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      needs: needsObj,
      workerCardTime: {}

    })
    .then(() => {
      dispatch(submitNeedsSuccess());
    })
    .catch(function (error) {
      dispatch(submitNeedsError(error));
    });
};
